/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pb_Community_OkInputs */

const en_pb_community_ok = /** @type {(inputs: Pb_Community_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} community playbooks from GitHub (tag bystep-playbook), refreshed every 30 minutes. Not reviewed by Bystep.`)
};

const id_pb_community_ok = /** @type {(inputs: Pb_Community_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} playbook komunitas dari GitHub (tag bystep-playbook), diperbarui tiap 30 menit. Tidak ditinjau Bystep.`)
};

/**
* | output |
* | --- |
* | "{n} community playbooks from GitHub (tag bystep-playbook), refreshed every 30 minutes. Not reviewed by Bystep." |
*
* @param {Pb_Community_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_community_ok = /** @type {((inputs: Pb_Community_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Community_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_community_ok(inputs)
	return en_pb_community_ok(inputs)
});